export default __webpack_public_path__ + "83f66aa8cdb1b3a3e0a6f23fea2f8286.png";